import { ACTION_SET_AUTH_STATUS } from "../auth/names.js";

/**
 * @param {Boolean} isAuth
 */
function changeAuthStatus(isAuth) {
  return {
    type: ACTION_SET_AUTH_STATUS,
    payload: isAuth,
  };
}

export default {
  changeAuthStatus,
};
